import { type FC } from 'react'
import { type BookingClient } from '../../../models/Scheduling'
import { clientDisplayName } from '../shared/schedulingDisplay'

// Up to two client names are listed; beyond that the first is shown with a "+ N other" overflow,
// markGuests appends a "(Guest)" label to clients that aren't contacts (History rows).
export const ContactChips: FC<{ clients: BookingClient[]; markGuests?: boolean }> = ({ clients, markGuests = false }) => {
  if (clients.length === 0) {
    return null
  }
  const shown = clients.length <= 2 ? clients : clients.slice(0, 1)
  const otherCount = clients.length - shown.length
  return (
    <span className='d-inline-flex align-items-center flex-wrap zocks-gap-0.25 paragraph-small zocks-text-gray-700'>
      {shown.map((client, index) => (
        <span key={client.contactId ?? client.email ?? index}>
          {clientDisplayName(client)}
          {markGuests && !client.contactId ? <span className='zocks-text-gray-600'> (Guest)</span> : null}
          {index < shown.length - 1 ? ',' : null}
        </span>
      ))}
      {otherCount > 0 ? <span className='zocks-text-gray-600'>+ {otherCount} other</span> : null}
    </span>
  )
}
